<div class="row w-100 pt-3 text-center margin-auto">
  <div class="col-12">
    <div class="row">
      <div class="information float-left bold-black-text" id="customer-full-name">{{ customer.civility + ' ' + customer.firstName + ' ' + customer.lastName }}</div>
    </div>

    <div class="row">
        @if (isPro) {
            <div class="information float-left bold-black-text" >
              Société {{customer.company}} ({{customer.siret}})
            </div>
        }
    </div>
  </div>
  <div class="col-12">
    @if (customerForm) {
        <form [formGroup]="customerForm" (submit)="save()">
            <div class="form-group">
                <span class="bold-label-text float-left">Email*:</span>
                <input type="text" class="form-control" placeholder="Adresse email" formControlName="email" required>
                @if (customerFormSubmitted && customerForm.controls.email.errors) {
                    <small class="form-text error-message">{{ getError('email') }}</small>
                }
            </div>
            <div class="form-group">
                <span class="bold-label-text float-left">N° téléphone:*</span>
                <input id="phone-number" type="text" class="form-control" placeholder="Téléphone" formControlName="phoneNumber">
                @if (customerFormSubmitted && customerForm.controls.phoneNumber.errors) {
                    <small class="form-text error-message">{{ getError('phoneNumber') }}</small>
                }
            </div>
            @if (isPro) {
                <div class="form-group">
                    <span class="bold-label-text float-left" [style.display]="routingAddressList.length > 1 ? 'block' : 'none'">Adresse de routage:</span>
                    <select formControlName="routingAddress" class="custom-select" [style.display]="routingAddressList.length > 1 ? 'block' : 'none'">
                        @for (routingAdr of routingAddressList; track routingAdr) {
                            <option [value]="routingAdr.value">{{ routingAdr.label }}</option>
                        }
                    </select>
                    <small class="form-text error-message text-center" [style.display]="routingAddressList.length <= 1 ? 'block' : 'none'">
                        Aucune adresse de routage n'a été trouvée dans l'annuaire
                    </small>
                </div>
                <div class="form-group">
                    <span class="bold-label-text float-left">Référence marché:</span>
                    <input id="codeService" type="text" class="form-control" placeholder="Référence marché" formControlName="codeService">
                </div>
                <div class="form-group">
                    <span class="bold-label-text float-left">Référence bon de commande:</span>
                    <input id="numeroCommande" type="text" class="form-control" placeholder="Référence bon de commande" formControlName="numeroCommande">
                </div>
                <div class="form-group">
                    <span class="bold-label-text float-left">Référence acheteur:</span>
                    <input id="buyerReference" type="text" class="form-control" placeholder="Référence acheteur" formControlName="buyerReference">
                </div>
            }
            <div class="cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button id="modify-button" type="submit" class="cta_btn level_2 column">Modifier<span></span></button>
            </div>
        </form>
    }
  </div>
</div>
